import template from 'product-store-availability.j2';
import { generate } from '@core/js/utils/componentUtils';

import { mDom } from '@core/js/utils/renderUtils';

import { getDefaultOptions } from '@core/js/utils/a15componentUtils';

import {
    default as accordionSupport
} from '@core/js/uiSupport/accordion';

import { onStateChange as commonOnStateChange } from '@product/js/utils/productComponentUtils';

import { launchAsyncBopisChangeStore } from '@product/js/utils/asyncLaunchers';
import { handleDefaultUrbnStoreSaga } from '@product/js/sagas/productBopisSagas';

function afterRender(store) {
    accordionSupport(this, this.templateLocation);
}

function attachEvents(store) {
    $(document).on(
        this.scopedEvent('click'),
        this.scopedSelector('.js-bopis-change-store'),
        (e) => {
            e.preventDefault();

            launchAsyncBopisChangeStore(store, e, this);
        }
    );
}

function onStateChange(store, watchValue, oldVal, newVal) {
    if (watchValue === "core.profile.profileId") {
        store.runSaga(handleDefaultUrbnStoreSaga, store.getState());
    }

    commonOnStateChange.bind(this)(store, watchValue, oldVal, newVal);
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-product-store-availability',
        attachEvents: attachEvents,
        afterRender: afterRender,
        onStateChange: onStateChange,
        targetedProduct: 'product',
        watch: ['core.profile.profileId', 'product.productBopis'],
        accordionNameDataAttr: 'data-accordion-tab-name',
        jsAccordionClass: '.js-accordion-tabset',
        template: template,
        name: 'productStoreAvailabilityComponent',
        renderType: mDom
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
